module.exports = __webpack_public_path__ + "img/periodicos-estrangeiros.1cdc3f3a.png";